module.exports = __webpack_public_path__ + "img/24.65152f9.png";